import React from "react";
import MuiIconButton from "@material-ui/core/IconButton";
import MuiMenu from "@material-ui/core/Menu";
import MuiMenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

export const ExlyIconButton = (props) => <MuiIconButton {...props} />;

export const ExlyMenu = (props) => <MuiMenu {...props} />;

export const ExlyMenuItem = (props) => <MuiMenuItem {...props} />;

export const ExlyMoreHorizIcon = (props) => <MuiMoreHorizIcon {...props} />;

const MuiMoreHorizIcon = MoreHorizIcon;
